var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rubric-library-cards"},_vm._l((_vm.rubrics),function(rubric){return _c(_vm.rubricComponent,_vm._g({key:rubric.id,tag:"component",attrs:{"selected-rubric":rubric,"is-selected":rubric.id === _vm.value?.id,"is-platform-rubric":_vm.isPlatformRubric}},_vm.$listeners))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }